import React from 'react';

export default function Modal({ baslik, onKapat, children }) {
  return (
    <div style={{ position:'fixed', top:0, left:0, right:0, bottom:0, background:'rgba(0,0,0,0.5)',
                  display:'flex', alignItems:'center', justifyContent:'center', zIndex:9999 }}>
      <div style={{ background:'white', borderRadius:8, padding:20, maxWidth:400, boxShadow:'0 4px 12px rgba(0,0,0,0.3)' }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
          <h2 style={{ margin:0, fontSize:16, fontWeight:700, color:'var(--mor)' }}>{baslik}</h2>
          <button style={{ background:'none', border:'none', fontSize:20, cursor:'pointer', color:'#999' }}
                  onClick={onKapat}>✕</button>
        </div>
        <div style={{ borderTop:'1px solid #eee', paddingTop:12 }}>
          {children}
        </div>
      </div>
    </div>
  );
}
